import {useCurrentScheduleQuery} from '@domain/schedule'
import {dataTestId} from '@hconnect/uikit'
import {useUpmPlantContext} from '@hconnect/upm'
import {Button} from '@mui/material'
import {useQueryClient} from '@tanstack/react-query'
import {usePlanningChartStartEnd} from '@widgets/planning-schedule-chart'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../../../consts'
import {useScheduleCostAvoidanceDialog} from '../../../../hooks'
import {
  SCHEDULE_COST_AVOIDANCE_QUERY_KEY,
  fetchScheduleCostAvoidance
} from '../../../../hooks/useScheduleCostAvoidanceQuery'

export const CalculateCostAvoidanceButton = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {plantId: plantCode} = useUpmPlantContext()
  const queryClient = useQueryClient()
  const {startOfPlan, endOfPlan} = usePlanningChartStartEnd()
  const {data: schedule} = useCurrentScheduleQuery({
    plantId: plantCode,
    range: [startOfPlan, endOfPlan]
  })
  const scheduleId = schedule?.scheduleId
  const {setIsDialogOpen} = useScheduleCostAvoidanceDialog()

  const handleCalculateCostAvoidance =
    scheduleId !== undefined
      ? () => {
          void queryClient.fetchQuery({
            queryKey: [SCHEDULE_COST_AVOIDANCE_QUERY_KEY, {plantCode, scheduleId}],
            queryFn: ({signal}) => fetchScheduleCostAvoidance(plantCode, scheduleId, signal)
          })
          setIsDialogOpen(true)
        }
      : undefined

  return (
    <Button
      variant="contained"
      id="calculate-cost-avoidance"
      onClick={handleCalculateCostAvoidance}
      {...dataTestId('calculate_cost_avoidance_button')}
    >
      {t('planning.calculateCostAvoidance')}
    </Button>
  )
}
